import { getOrderStatisticsPrimaryPhase, getStatisticsLensData } from './orderPrimaryPhaseConfig';
import { ORDER_PRIMARY_PHASE_DIMENSIONS } from './orderPrimaryPhaseDimension';
import { DEFAULT_ACTIVE_METRICS, resolveChartPrimaryMetric } from './orderPrimaryPhaseMetric';
import { aggregatePrimaryPhaseLensFromOrders } from './aggregatePrimaryPhaseLensFromOrders';
import { aggregatePrimaryPhaseOrdersByDimension } from './aggregatePrimaryPhaseOrdersByDimension';

const resolvePhaseScopedOrders = (orders = [], selectedPhase) => {
	if (!selectedPhase) return orders;
	return orders.filter((order) => getOrderStatisticsPrimaryPhase(order) === selectedPhase);
};

/**
 * 从 primaryPhaseStats API 结果组装 pipeline-* 图表展示 bundle（复制 live / 首页 pin live / 定格数据源）。
 */
export const buildPipelineChartBundle = ({
	snapshot = null,
	primaryPhaseStats = null,
	isStatisticsQueryLoading = false,
	isStatisticsQueryFetching = false,
} = {}) => {
	const chartKind = snapshot?.chartKind ?? null;
	const selectedPhase = snapshot?.selectedPhase ?? null;
	const activeDimension = snapshot?.ui?.activeDimension ?? ORDER_PRIMARY_PHASE_DIMENSIONS.SALE_USER;
	const activeMetric = snapshot?.ui?.activeMetric ?? resolveChartPrimaryMetric(DEFAULT_ACTIVE_METRICS);
	const filters = snapshot?.filters ?? snapshot?.scope ?? {};
	const orders = Array.isArray(primaryPhaseStats?.orders) ? primaryPhaseStats.orders : [];
	const chartAggregates = primaryPhaseStats?.chartAggregates ?? null;
	const fullLensData = getStatisticsLensData(primaryPhaseStats);
	const phaseScopedOrders = resolvePhaseScopedOrders(orders, selectedPhase);

	let lensData = fullLensData;
	if (selectedPhase) {
		if (orders.length > 0) {
			lensData = aggregatePrimaryPhaseLensFromOrders(phaseScopedOrders, filters);
		} else {
			const phaseRow = fullLensData?.phases?.find((row) => row.phase === selectedPhase);
			if (phaseRow) {
				lensData = {
					overview: {
						count: phaseRow.count,
						totalPrice: phaseRow.totalPrice,
						receivableTotal: phaseRow.receivableTotal,
						quasiReceivableTotal: phaseRow.quasiReceivableTotal,
						pendingPrepaymentTotal: phaseRow.pendingPrepaymentTotal,
						paidPrepaymentTotal: phaseRow.paidPrepaymentTotal,
					},
					phases: [phaseRow],
				};
			}
		}
	}

	const aggregateRows = chartAggregates?.dimensions?.[activeDimension];
	let dimensionRows = aggregateRows ?? [];
	if (selectedPhase && orders.length > 0) {
		dimensionRows = aggregatePrimaryPhaseOrdersByDimension(phaseScopedOrders, activeDimension, { filters });
	} else if (!selectedPhase && Array.isArray(aggregateRows) && aggregateRows.length > 0) {
		dimensionRows = aggregateRows;
	} else if (orders.length > 0) {
		dimensionRows = aggregatePrimaryPhaseOrdersByDimension(phaseScopedOrders, activeDimension, { filters });
	}

	const loading = Boolean(isStatisticsQueryLoading || isStatisticsQueryFetching) && !primaryPhaseStats;

	return {
		chartKind,
		activeMetric,
		activeDimension,
		selectedPhase,
		lensData,
		dimensionRows,
		chartAggregates,
		orders,
		highlightProvinceNames: [],
		highlightAnchorCityRows: [],
		overdueData: null,
		chartLoading: loading,
		trendChartLoading: loading,
		isStatisticsQueryLoading: Boolean(isStatisticsQueryLoading),
		isStatisticsQueryFetching: Boolean(isStatisticsQueryFetching),
		animationKey: `pipeline-${snapshot?.id ?? 'chart'}-${selectedPhase ?? 'all'}-${primaryPhaseStats?.currentPeriod?.startDate ?? ''}`,
	};
};
